<div *ngIf="!isLoading else loading">
<form class="settings-general" [formGroup]="validateUserFormGroup" novalidate autocomplete="off" *ngIf="!isInValidSessionToken">
	<div class="transversal-toolbar">
		<mat-icon class="transversal-header-arcelormittal" svgIcon="am_with_text"></mat-icon>
		<h1 class="transversal-header-steeluser" translate>validate-user.steeluser</h1>
		<div class="transversal-header-user-icons">
			<div class="button-container">
				<button mat-flat-button color="primary" mat-ripple type="submit" (click)="submit()"
					[disabled]="this.validateUserFormGroup.invalid">
					<span translate>validate-user.submit</span>
				</button>
			</div>
		</div>
	</div>
	<div *ngIf="this.isPasswordExpired">
		<span class="user-password-expired" translate>user.password.expired.text</span>
	</div>
	<div class="validate-user-content">
		<div class="card-block">
			<div class="card-title">
				<span translate>confirm-password-legacy.user-information</span>
			</div>
			<div class="card-block-body" *ngIf="!isLoading else loading">
				<div class="grid-3">
					<mat-form-field class="card-block-form-field" appearance="standard" floatLabel="always">
						<mat-label translate>validate-user.firstname</mat-label>
						<input class="input-field" matInput formControlName="firstName" type="text" autocomplete="off" required>
						<mat-error *ngIf="firstName && firstName.errors && firstName.errors['required']" translate>
							validate-user.required</mat-error>

					</mat-form-field>
					<mat-form-field class="card-block-form-field" appearance="standard" floatLabel="always">
						<mat-label translate>validate-user.lastname</mat-label>
						<input class="input-field" matInput formControlName="lastName" type="text" autocomplete="off" required>
						<mat-error *ngIf="lastName && lastName.errors && lastName.errors['required']" translate>
							validate-user.required</mat-error>

					</mat-form-field>
					<mat-form-field class="card-block-form-field" appearance="standard" floatLabel="always">
						<mat-label translate>validate-user.email</mat-label>
						<input class="input-field" matInput formControlName="email" type="text" autocomplete="off" required>
						<mat-error *ngIf="email && email.errors && email.errors['required'] else otherError" translate>
							validate-user.required</mat-error>
						<ng-template #otherError>
							<mat-error translate>validate-user.invalid-mail-id</mat-error>
						</ng-template>
					</mat-form-field>
				</div>
				<div class="grid-3">
					<mat-form-field class="card-block-form-field" appearance="standard" floatLabel="always">
						<mat-label translate>validate-user.login</mat-label>
						<input class="input-field" matInput formControlName="username" type="text" autocomplete="off" required>
						<mat-error *ngIf="username && username.errors && username.errors['required']" translate>
							validate-user.required</mat-error>
					</mat-form-field>
					<mat-form-field *ngIf="this.isPasswordExpired" class="card-block-form-field" appearance="standard" floatLabel="always">
						<mat-label translate>validate-user.old-password</mat-label>
						<input matInput formControlName="oldPassword" type="password" autocomplete="off" required>
						<mat-error
							*ngIf="oldPassword && oldPassword.errors && oldPassword.errors['required']"
							translate>validate-user.required</mat-error>
					</mat-form-field>
					<mat-label translate *ngIf="this.isPasswordExpired">
						<a [routerLink]="['/forgot-password']">{{ 'dont.remember.old.password' | translate }}</a>
					</mat-label>
					<mat-form-field class="card-block-form-field" appearance="standard" floatLabel="always">
						<mat-label translate>validate-user.password</mat-label>
						<input matInput formControlName="password" type="password" autocomplete="off" minlength="15"
							required [pattern]="passwordPatternStr">
						<mat-error
							*ngIf="password && password.errors && password.errors['required'] else otherNewPwdError"
							translate>validate-user.required</mat-error>
						<ng-template #otherNewPwdError>
							<mat-error translate>validate-user.password-doesnt-match-rules</mat-error>
						</ng-template>
					</mat-form-field>

					<mat-form-field class="card-block-form-field" appearance="standard" floatLabel="always">
						<mat-label translate>validate-user.confirm-password</mat-label>
						<input matInput formControlName="confirmPassword" type="password" autocomplete="off"
							minlength="15" required [pattern]="passwordPatternStr">
						<mat-error
							*ngIf="validateUserFormGroup && confirmPassword && confirmPassword.errors && confirmPassword.errors['required']"
							translate>validate-user.required</mat-error>
						<mat-error
							*ngIf="validateUserFormGroup && confirmPassword && confirmPassword.errors && confirmPassword.errors['notMatch']"
							translate>validate-user.confirm-password-match</mat-error>
					</mat-form-field>
					<div>
						<div class="copo-medium-grey">
							<div translate>validate-user.password-must-contain-title</div>
							<div>
								<span [ngClass]="{'copo-orange-text-icon': validateUserFormGroup && validateUserFormGroup.controls['password'].value && !match('charLength'),
							'copo-green': validateUserFormGroup && validateUserFormGroup.controls['password'].value && match('charLength')}"
									translate>validate-user.15-character-rule</span>
							</div>
							<div>
								<span [ngClass]="{'copo-orange-text-icon': validateUserFormGroup && validateUserFormGroup.controls['password'].value && !match('lower'),
							'copo-green': validateUserFormGroup && validateUserFormGroup.controls['password'].value && match('lower')}"
									translate>validate-user.1-lowercase-letter-rule</span>
							</div>
							<div>
								<span [ngClass]="{'copo-orange-text-icon': validateUserFormGroup && validateUserFormGroup.controls['password'].value && !match('upper'),
							'copo-green': validateUserFormGroup && validateUserFormGroup.controls['password'].value && match('upper')}"
									translate>validate-user.1-uppercase-letter-rule</span>
							</div>
							<div>
								<span [ngClass]="{'copo-orange-text-icon': validateUserFormGroup && validateUserFormGroup.controls['password'].value && !match('number'),
							'copo-green': validateUserFormGroup && validateUserFormGroup.controls['password'].value && match('number')}"
									translate>validate-user.1-number-rule</span>
							</div>
							<div>
								<span [ngClass]="{'copo-orange-text-icon': validateUserFormGroup && validateUserFormGroup.controls['password'].value && !match('special'),
								'copo-green': validateUserFormGroup && validateUserFormGroup.controls['password'].value && match('special')}"
									translate>validate-user.1-special-character-rule</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="card-block">
			<div class="card-title">
				<span translate>validate-user.service-info</span>
			</div>
			<div *ngIf="!isLoading else loading">
				<table mat-table [dataSource]="serviceList" class="mat-elevation-z8"
					*ngIf="serviceList && serviceList.length>0">
					<ng-container matColumnDef="name">
						<th mat-header-cell *matHeaderCellDef>Name</th>
						<td mat-cell *matCellDef="let element"> {{element.name}} </td>
					</ng-container>
					<ng-container matColumnDef="description">
						<th mat-header-cell *matHeaderCellDef> Description </th>
						<td mat-cell *matCellDef="let element"> {{element.description}} </td>
					</ng-container>
					<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
					<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
				</table>
				<div *ngIf="!serviceList || serviceList.length === 0" class="card-title-label">No services</div>
			</div>
		</div>
		<div class="card-block">
			<div class="card-title">
				<span translate>validate-user.org-info</span>
			</div>
			<div class="card-info" *ngIf="(!isLoading && orgInfo) else loading">
				<span class="card-info-label" translate>validate-user.company-name</span>
				<span class="card-info-label">:</span>
				<span class="card-info-value">
					{{orgInfo.name}}
				</span>
			</div>
		</div>
	</div>
</form>
<h1 class="centered-container" *ngIf="isInValidSessionToken" translate>{{tokenExpiredMessage}}</h1>
</div>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>